var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFeedposts = function SvgFeedposts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M34.667 21.776V8.365c0-2.96-2.392-5.365-5.334-5.365h-24C2.392 3 0 5.406 0 8.365v13.41c0 2.96 2.392 5.365 5.333 5.365v4.543c0 .671.759 1.057 1.292.654l6.9-5.205h15.808c2.942.008 5.334-2.397 5.334-5.356zm8-5.365h-5.334v5.365c0 4.434-3.591 8.047-8 8.047H16v5.364c0 2.959 2.392 5.365 5.333 5.365h10.475l6.9 5.205c.534.402 1.292.017 1.292-.654v-4.551h2.667c2.941 0 5.333-2.406 5.333-5.365V21.776c0-2.959-2.392-5.365-5.333-5.365z"
  })));
};
export default SvgFeedposts;